import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export const Route = createFileRoute("/oauth/google/return")({
  component: OAuthReturn,
  head: () => ({
    meta: [
      { title: "Finishing your Google connection · Pyng" },
      { name: "description", content: "Pyng is securely finishing your Google account connection." },
      { name: "robots", content: "noindex" },
    ],
  }),
});

function OAuthReturn() {
  const [message, setMessage] = useState("Finishing connection…");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const connectorId = params.get("connector_id") ?? "";
    const notify = (
      type: "appUserConnectorOAuthComplete" | "appUserConnectorOAuthFailed",
      reason?: { error?: string | null; errorDescription?: string | null; code?: string | null },
    ) => {
      window.opener?.postMessage(
        {
          type,
          connectorId,
          code: reason?.code ?? null,
          error: reason?.error ?? null,
          errorDescription: reason?.errorDescription ?? null,
        },
        window.location.origin,
      );
      window.close();
    };
    if (params.get("success") !== "true") {
      const error = params.get("error");
      const errorDescription = params.get("error_description");
      setMessage(errorDescription ?? error ?? "Google didn't complete the connection.");
      notify("appUserConnectorOAuthFailed", { error, errorDescription });
      return;
    }
    const code = params.get("code");
    if (!code) {
      if (params.get("offline_access_allowed") === "false") {
        notify("appUserConnectorOAuthComplete");
        return;
      }
      setMessage("Connection finished without an exchange code.");
      notify("appUserConnectorOAuthFailed", { error: "missing_code" });
      return;
    }
    // The exchange runs in the opener: inside the embedded preview this popup
    // has no app session (partitioned storage), so authed server fns 401 here.
    notify("appUserConnectorOAuthComplete", { code });
  }, []);

  return (
    <main className="grid min-h-screen place-items-center px-6">
      <p className="text-sm text-muted-foreground">{message}</p>
    </main>
  );
}
